import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
    standalone: false
})
export class BackButtonComponent {

  @Output() backClick = new EventEmitter<void>();

}
